import redirects from '../../data/redirectsEntries.json'

export const getRedirects = () => {
  if (typeof redirects === 'undefined') {
    return []
  } else {
    return redirects.filter((redirect) => redirect.enabled)
  }
}
